export interface SiteDataProps {
  name: string;
  title: string;
  description: string;
  supportEmail: string;
  url: string;
  installUrl: string;
}

const siteData: SiteDataProps = {
  name: "SendKit",
  title: "SendKit",
  description:
    "SendKit streamlines newsletters and transactional email, and lets AI agents design, preview, and schedule campaigns with human approval.",
  supportEmail: "support@send-kit.com",
  url: "https://send-kit.com",
  installUrl: "https://apps.shopify.com/sendkit-email",
};

export default siteData;
